/**
 * Utility functions for mapping survey questions to resilience anchors.
 * Kept separate from existing codebase.
 */

export const getAnchorForGroup = (groupId) => {
  /**
   * Map question group ID to resilience anchor.
   * Groups 8-11: Identity
   * Group 12: Future Orientation
   * Group 13: Ability
   * Groups 14-16: Execution
   * Group 17: Social Immunity
   */
  if ([8, 9, 10, 11].includes(groupId)) {
    return 'identity';
  } else if (groupId === 12) {
    return 'future_orientation';
  } else if (groupId === 13) {
    return 'ability';
  } else if ([14, 15, 16].includes(groupId)) {
    return 'execution';
  } else if (groupId === 17) {
    return 'social_immunity';
  }
  return null;
};

export const getAnchorName = (anchorKey) => {
  const names = {
    identity: 'Identity',
    future_orientation: 'Future Orientation',
    ability: 'Ability',
    execution: 'Execution',
    social_immunity: 'Social Immunity'
  };
  return names[anchorKey] || anchorKey;
};

export const getAnchorColor = (anchorKey) => {
  const colors = {
    identity: '#3B82F6', // Blue
    future_orientation: '#10B981', // Green
    ability: '#F59E0B', // Amber
    execution: '#EF4444', // Red
    social_immunity: '#8B5CF6' // Purple
  };
  return colors[anchorKey] || '#6B7280';
};

export const getSubFactorForGroup = (groupId) => {
  const subFactors = {
    8: 'Values',
    9: 'Personality',
    10: 'Strengths',
    11: 'Knowledge, Skills, Experience',
    12: 'Action & Commitment',
    13: 'Learnability, Quality, Integrity',
    14: 'Adaptability',
    15: 'Perseverance',
    16: 'Positivity',
    17: 'People Orientation & Vulnerability Comfort'
  };
  return subFactors[groupId] || 'Unknown';
};
